module.exports = {
  DATA_CONTEXT: 'tokenizer-context:data',
  OPEN_TAG_START_CONTEXT: 'tokenizer-context:open-tag-start',
  CLOSE_TAG_CONTEXT: 'tokenizer-context:close-tag',
  ATTRIBUTES_CONTEXT: 'tokenizer-context:attributes',
  OPEN_TAG_END_CONTEXT: 'tokenizer-context:open-tag-end',
  ATTRIBUTE_KEY_CONTEXT: 'tokenizer-context:attribute-key',
  ATTRIBUTE_VALUE_CONTEXT: 'tokenizer-context:attribute-value',
  ATTRIBUTE_VALUE_BARE_CONTEXT: 'tokenizer-context:attribute-value-bare',
  ATTRIBUTE_VALUE_WRAPPED_CONTEXT: 'tokenizer-context:attribute-value-wrapped',
  SCRIPT_CONTENT_CONTEXT: 'tokenizer-context:script-content',
  STYLE_CONTENT_CONTEXT: 'tokenizer-context:style-content',
  DOCTYPE_START_CONTEXT: 'tokenizer-context:doctype-start',
  DOCTYPE_END_CONTEXT: 'tokenizer-context:doctype-end',
  DOCTYPE_ATTRIBUTES_CONTEXT: 'tokenizer-context:doctype-attributes',
  DOCTYPE_ATTRIBUTE_WRAPPED_CONTEXT: 'tokenizer-context:doctype-attribute-wrapped',
  DOCTYPE_ATTRIBUTE_BARE_CONTEXT: 'tokenizer-context:doctype-attribute-bare',
  COMMENT_START_CONTEXT: 'tokenizer-context:comment-start',
  COMMENT_CONTENT_CONTEXT: 'tokenizer-context:comment-content',
  COMMENT_END_CONTEXT: 'tokenizer-context:comment-end'
}
